import ScrollOut from "scroll-out";

ScrollOut({
  once: true,
  threshold: 0.3,
});
